import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IChatTransferred {
  readonly id: string;
  readonly type: MESSAGES.CHAT_TRANSFERRED;
  readonly rm: false;
  readonly role?: string;
}

export const chatTransferred = (data): IChatTransferred => ({
  id: data.id || uuid(),
  type: MESSAGES.CHAT_TRANSFERRED,
  rm: false,
});
